// Navigation Module
$(function () {
    'use strict';

    if (window.pz === undefined) {
        window.pz = {};
    }

    pz.nav = function () {

        var initModule = function () {

            // Primary nav event handlers

            // Handle primary nav bar mouseenter
            $('.js-nav-bar').on('mouseenter', 'li', function (event) {
                openPrimaryNavSection($(this));
            });

            // Handle primary nav bar mouseleave
            $('.js-primary-nav').on('mouseleave', function (event) {
                closePrimaryNav();
            });

            // Match height accross nav sections
            $('.js-section-nav').matchHeight();

            // Mobile nav event handlers

            // Handle mobile nav icon click
            $('.js-menu-icon').on('click', function (event) {
                toggleMobileNavOpen();
            });

            // Handle mobile nav section click
            $('.js-mobile-nav-section-trigger').on('click', function (event) {
                var $section = $(this).parent().find('.js-mobile-nav-section-contents');
                if ($section.hasClass('active')) {
                    closeAllMobileNavSections();
                } else {
                    closeAllMobileNavSections();
                    openMobileNavSection($(this));
                }
            });

            // Hide mobile nav above 640 on window resize
            $(window).on("resize", function () {
                if ($(window).width() > 640) {
                    hideMobileNav();
                }
            });
        };

        var openPrimaryNavSection = function ($element) {
            $element.siblings().removeClass('active');
            $element.addClass('active');

            var section = $element.attr('data-section');

            $('.js-section-nav').removeClass('active');
            $('.js-section-nav.' + section).addClass('active');
            $('.js-section-nav-container').addClass('active');

            TweenLite.to($('.js-section-nav-container'), 0.5, {
                height: 200,
                ease: Power2.easeInOut,
                onComplete: function onComplete() {}
            });
        };

        var closePrimaryNav = function () {
            TweenLite.to($('.js-section-nav-container'), 0.5, {
                height: 0,
                ease: Power2.easeInOut,
                onComplete: function onComplete() {
                    $('.js-nav-bar li').removeClass('active');
                    $('.js-section-nav-container').removeClass('active');
                    $('.js-section-nav').removeClass('active');
                }
            });
        };

        var toggleMobileNavOpen = function () {
            if ($('.js-mobile-nav').hasClass('active')) {
                $('.js-menu-icon').removeClass('active');
                $('.js-mobile-nav').removeClass('active');
            } else {
                $('.js-menu-icon').addClass('active');
                $('.js-mobile-nav').addClass('active');
            }
        };

        var closeAllMobileNavSections = function () {
            $('.js-mobile-nav-section-trigger').removeClass('active');
            $('.js-mobile-nav-section-contents').removeClass('active');
        };

        var openMobileNavSection = function ($element) {
            var $section = $element.parent().find('.js-mobile-nav-section-contents');
            $element.addClass('active');
            $section.addClass('active');
        };

        var hideMobileNav = function () {
            $('.js-menu-icon').removeClass('active');
            $('.js-mobile-nav').removeClass('active');
            $('.js-mobile-nav-section-trigger').removeClass('active');
            $('.js-mobile-nav-section-contents').removeClass('active');
        };

        return {
            initModule: initModule
        };
    }();

    pz.nav.initModule();
});